export const getPageEventsReportTableRows = (data) => {
	const rows = data.map((d, i) => (
		<tr key={i}>
			<td>{i + 1}</td>
			<td>{d['pageVariant']}</td>
			<td>{d['sourceEventCount']}</td>
			<td>{d['targetEventCount']}</td>
		</tr>
	));

	return rows;
};
